import { Dispatch } from '@reduxjs/toolkit';
import { connect } from "react-redux";

import { AuthSettingsView } from "../view/view";
import { RootState } from '../../../app/store';
import { actions } from '../actions/Action';
import { requestAuthSettingsFromAPI, saveAuthSettingsToAPI, testConnectionOnAPI } from '../thunk/request_func';
import {
    AuthProvider, AuthSecrets, AuthSettings, ConnectionKind, KeycloakField, LdapField, ProvisionRole,
} from '../typing/generalType';

interface OwnProps {
    id: string;
}

function mapStateToProps(state: RootState, _ownProps: OwnProps) {
    return {
        settings: state.AuthSettings.model.settings,
        secrets: state.AuthSettings.model.secrets,
        status: state.AuthSettings.view,
        role: state.LoginManager.model.role,
    };
}

// Without ownProps, so the callbacks are bound once and stay stable for
// the view's useEffect.
function bindDispatchToActions(dispatch: Dispatch<any>) {
    return {
        onLoadRequested: () => dispatch(requestAuthSettingsFromAPI() as any),
        onProvidersChange: (providers: readonly AuthProvider[]) =>
            dispatch(actions.setProviders({ providers })),
        onProvisionRoleChange: (role: ProvisionRole) =>
            dispatch(actions.setProvisionRole({ role })),
        onLdapChange: (field: LdapField, value: string | number | boolean | null) =>
            dispatch(actions.setLdapField({ field, value })),
        onKeycloakChange: (field: KeycloakField, value: string | boolean) =>
            dispatch(actions.setKeycloakField({ field, value })),
        onSecretChange: (field: keyof AuthSecrets, value: string) =>
            dispatch(actions.setSecret({ field, value })),
        onSave: (settings: AuthSettings, secrets: AuthSecrets, savedText: string) =>
            dispatch(saveAuthSettingsToAPI(settings, secrets, savedText) as any),
        onTest: (kind: ConnectionKind) => dispatch(testConnectionOnAPI(kind) as any),
    };
}

const AuthSettingsContainer = connect(mapStateToProps, bindDispatchToActions)(AuthSettingsView);
export default AuthSettingsContainer;
